// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    english: {
      translation: {
        features: {
          appointments: "Appointments",
          appointmentsDesc: "Talk to Experts",
          feelHeard: "Feel Heard",
          feelHeardDesc: "Chat Buddy: Instant support when you need to feel heard—your empathetic companion.",
          soundTherapy: "Sound Therapy",
          soundTherapyDesc: "Daily Wellness: Calm your mind daily with soothing audio therapy."
        },
        certifications: {
          iso: "ISO 27001 Certified",
          wfmh: "WFMH Member",
          hipaa: "HIPAA Compliant"
        },
        care: {
          title: "Care",
          dailyBreathing: "Daily Breathing",
          rejuvenateSounds: "Rejuvenate with echo sounds",
          echoSoundscapes: "Echo Soundscapes",
          manageThoughts: "Manage your Thoughts",
          gratitudeJournal: "Gratitude Journal",
          moodCheckin: "Mood Check-in",
          labelFrequency: "Frequency Sound",
          labelActivity: "Activity"
        },
        dailyBreathing: {
          title: "Daily Breathing",
          desc: `Take 3 minutes to pause and breathe.
Feel your stress melt away, your mind clear, and your body recharge.
A simple breath can restore balance, energy, and calm.`,
          subtitle: "Breathe in peace, exhale stress"
        }
      }
    },
    hindi: {
      translation: {
        features: {
          appointments: "अपॉइंटमेंट्स",
          appointmentsDesc: "विशेषज्ञों से बात करें",
          feelHeard: "सुनवाई",
          feelHeardDesc: "चैट साथी: जब आपको सुने जाने की आवश्यकता हो तो तुरंत समर्थन—आपका सहानुभूतिपूर्ण साथी।",
          soundTherapy: "साउंड थेरेपी",
          soundTherapyDesc: "दैनिक स्वास्थ्य: सुकूनदायक ऑडियो थेरेपी से प्रतिदिन मन को शांत करें।"
        },
        certifications: {
          iso: "ISO 27001 प्रमाणित",
          wfmh: "WFMH सदस्य",
          hipaa: "HIPAA अनुपालन"
        },
        care: {
          title: "देखभाल",
          dailyBreathing: "दैनिक श्वास",
          rejuvenateSounds: "इको ध्वनियों से तरोताजा",
          echoSoundscapes: "इको साउंडस्केप्स",
          manageThoughts: "मेरे विचारों का प्रबंधन करें",
          gratitudeJournal: "कृतज्ञता जर्नल",
          moodCheckin: "मूड चेक-इन",
          labelFrequency: "आवृत्ति ध्वनि",
          labelActivity: "गतिविधि"
        },
        dailyBreathing: {
          title: "दैनिक श्वास",
          desc: `3 मिनट के लिए रुकें और सांस लें।
अपने तनाव को पिघलते देखें, मन को शांत करें और शरीर को ऊर्जा दें।
एक साधारण सांस संतुलन, ऊर्जा और शांति बहाल कर सकती है।`,
          subtitle: "शांति के साथ साँस लें, तनाव छोड़ें"
        }
      }
    }
  },
  lng: localStorage.getItem("language") || "english", // default
  fallbackLng: "english",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
